import React, { FC } from 'react';

import { defineMessages, useIntl } from 'react-intl';

import { AbsoluteBackgroundImage } from 'enums/absolute-background-image';
import { useUIContext } from 'state/ui';

import {
  AddIcon,
  AddToCardBtn,
  AddToCardBtnText,
  BtnContainer,
  CardContent,
  Container,
  EditIcon,
  ExclamationIcon,
  IconBtn,
  Image,
  Name,
  NotAvailableText,
  ProductImg
} from './styled';
import { IRecentOrderCardProps } from './types';

const RecentOrderCard: FC<IRecentOrderCardProps> = ({
  productImage,
  backgroundImage,
  showEdit = false,
  isAvailable,
  marginRight = '0',
  name,
  addToCartOnClick,
  editItemOnClick
}) => {
  const { buildImageUrl } = useUIContext();
  const { formatMessage } = useIntl();

  let buttonContent = (
    <AddToCardBtn onClick={addToCartOnClick} data-testid="single-add-to-cart-btn">
      <AddIcon />
      <AddToCardBtnText>{formatMessage(messages.addToCart)}</AddToCardBtnText>
    </AddToCardBtn>
  );
  if (showEdit) {
    buttonContent = (
      <>
        <IconBtn onClick={addToCartOnClick} data-testid="add-to-cart-btn">
          <AddIcon />
        </IconBtn>
        <IconBtn onClick={editItemOnClick} data-testid="edit-btn">
          <EditIcon />
        </IconBtn>
      </>
    );
  }
  if (!isAvailable) {
    buttonContent = (
      <NotAvailableText data-testid="not-available-in-store">
        <ExclamationIcon>!</ExclamationIcon>
        <span>{formatMessage(messages.notAvailableAtStore)}</span>
      </NotAvailableText>
    );
  }
  return (
    <Container marginRight={marginRight}>
      <Image
        backgroundImageUrl={
          backgroundImage && backgroundImage.asset
            ? buildImageUrl(backgroundImage, {
                width: AbsoluteBackgroundImage.WIDTH,
                height: AbsoluteBackgroundImage.HEIGHT,
                format: 'jpg'
              })
            : ''
        }
      >
        <ProductImg image={productImage} alt={name} />
      </Image>
      <CardContent>
        <Name isAvailable={isAvailable}>{name}</Name>
        <BtnContainer>{buttonContent}</BtnContainer>
      </CardContent>
    </Container>
  );
};

export default RecentOrderCard;
const messages = defineMessages({
  notAvailableAtStore: {
    id: 'notAvailableAtStore',
    defaultMessage: 'Not available',
    description: 'No description'
  },

  addToCart: {
    id: 'add',
    defaultMessage: 'Add',
    description: 'Add to cart'
  }
});
